import React from 'react'
import MenuAppBar from './MenuAppBar'
import styled, {createGlobalStyle} from 'styled-components'
import {Outlet} from 'react-router-dom'
import Container from '@mui/material/Container'
import Footer from './Footer'
import AuthProvider from '@/auth/AuthProvider'

const LayoutWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`

const Main = styled.main`
    padding-left: 40px;
    position: relative;
    flex-grow: 1;
`

const GlobalStyle = createGlobalStyle`
    html, body {
        background-color: ${({theme}: any) => theme.palette.primary['300']};
    }
`

export default function AuthLayout() {
    return (
        <AuthProvider>
            <LayoutWrapper>
                <MenuAppBar/>
                <Main>
                    <Container maxWidth='xl'>
                        <Outlet/>
                    </Container>
                </Main>
                <GlobalStyle/>
                <Footer/>
            </LayoutWrapper>
        </AuthProvider>
    )
}
